import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { getDocumentSeries } from '../../../redux/actions/API/documentSeriesAction';
import { Button, DatePicker, Drawer, Input, notification, Select, Space, Switch, Table } from 'antd';
import moment from 'moment';
import { DeleteOutlined } from '@ant-design/icons';
import { createSelectBatchItems } from '../../../redux/actions/API/batchItems';
import Loader from '../../../Home/Loader/Loader';
import { useDispatch } from 'react-redux';
import { getInventoryApprovalById } from '../../../redux/actions/API/inventoryApprovalAction';
import { isValidJSON } from '../../utility/itemsUtility';
import BarcodePrint from './BarcodePrint';

interface Props {
    isDrawerOpen: boolean;
    setIsDrawerOpen: Function;
    itemsData: any;
    seriesData: any;
    companyId: string;
    getDocumentSeries: Function;
    createSelectBatchItems: Function;
    loading: boolean;
    message: string;
    approvalId: any;
    getInventoryApprovalById: Function;
    userId: string;
    batchesData: any;
    selectedItemsData: any;
}

const AddSelectBatch: React.FC<Props> = ({
    isDrawerOpen, setIsDrawerOpen, itemsData,
    seriesData, companyId, getDocumentSeries,
    createSelectBatchItems, loading, message,
    userId, getInventoryApprovalById, approvalId,
    batchesData, selectedItemsData
}) => {

    const [dataSource, setDataSource] = useState<any>([]);
    const [series, setSeries] = useState<any>(null);
    const [toggle, setToggle] = useState(true);
    const [selectedDataSource, setSelectedDataSource] = useState<any>([]);
    const [isVisible, setIsVisible] = useState(false);
    const [printData, setPrintData] = useState<any>([]);

    const dispatch = useDispatch();

    useEffect(() => {
        getDocumentSeries({ companyId });
    }, []);

    const recalculateSequences = (
        data: any[],
        startingNumber: number,
        prefix: string
    ) => {
        let counter = startingNumber;

        return data.map((parent: any) => {
            if (parent.key === "globalParent") {
                return {
                    ...parent,
                    prefix,
                    sequence: startingNumber
                };
            }

            const updatedChildren = parent.children?.map((child: any) => {
                const updated = {
                    ...child,
                    prefix,
                    sequence: counter
                };
                counter += 1;
                return updated;
            });

            return {
                ...parent,
                prefix,
                sequence: updatedChildren?.[0]?.sequence || counter,
                children: updatedChildren
            };
        });
    };

    const handleDeleteRow = (subKey: string) => {

        const updatedData = dataSource.map((parent: any) => {
            if (!parent.children) return parent;

            const filteredChildren = parent.children.filter(
                (child: any) => child.key !== subKey
            );

            return {
                ...parent,
                children: filteredChildren,
                split: filteredChildren.length || ''
            };
        });

        const selectedSeries = seriesData?.find(
            (s: any) => s.prefix === series
        );

        const startingNumber = selectedSeries?.nextNumber || 1;

        const recalculated = recalculateSequences(
            updatedData,
            startingNumber,
            series
        );

        setDataSource(recalculated);
    };

    const validateChildQuantities = (parent: any): boolean => {
        if (!parent?.children?.length || parent.quantity === undefined || parent.quantity === '') return true;
        const sum = parent.children.reduce((total: number, child: any) => {
            const qty = parseFloat(child.quantity);
            return total + (isNaN(qty) ? 0 : qty);
        }, 0);
        return Number(parent.quantity) === sum;
    };

    const columns = [
        {
            title: '#',
            dataIndex: 'key',
            render: (_: any, record: any, index: number) => record.key == 'globalParent' ? '' : record.itemId ? <strong>{index}</strong> : index + 1
        },
        {
            title: 'Item Id',
            dataIndex: 'itemId',
            render: (_: any, record: any, index: number) => {
                return record.key == 'globalParent' ? '' : record?.itemId ? (<div>
                    {
                        <strong>{_ || ''}</strong>
                    }
                </div>) : ''
            }
        },
        {
            title: 'Item Name',
            dataIndex: 'itemName',
            render: (_: any, record: any, index: number) => {
                return record.key == 'globalParent' ? '' : <div>
                    {
                        <strong>{_ || ''}</strong>
                    }
                </div>
            }
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            render: (text: any, record: any, index: number) => {
                if (record.key == 'globalParent') return ''
                const isParent = !!record.itemId;

                if (isParent) {
                    const isValid = validateChildQuantities(record);
                    return (
                        <>
                            {record.key != 'globalParent' ? <Space direction="vertical">
                                <Space>
                                    <Input
                                        style={{ width: '50px' }}
                                        value={record?.quantity}
                                        disabled
                                    />
                                    <div style={{ width: '70px' }}>{record?.UOM}</div>
                                    <Input
                                        value={record.split}
                                        onChange={(e) => {
                                            const onlyDigits = e.target.value.replace(/\D/g, '');
                                            const newData = [...dataSource];

                                            const splitCount = Number(onlyDigits);
                                            const parent = newData[index];

                                            if (!splitCount) return;

                                            let newChildren = [...(parent.children || [])];

                                            if (splitCount > newChildren.length) {
                                                while (newChildren.length < splitCount) {
                                                    newChildren.push({
                                                        key: `${parent.key}-${newChildren.length + 1}`,
                                                        quantity: '',
                                                        manufacturingDate: '',
                                                        expiryDate: '',
                                                        prefix: parent.prefix || ''
                                                    });
                                                }
                                            } else {
                                                newChildren = newChildren.slice(0, splitCount);
                                            }

                                            newData[index] = {
                                                ...parent,
                                                children: newChildren,
                                                split: onlyDigits
                                            };

                                            const selectedSeries = seriesData?.find(
                                                (s: any) => s.prefix === series
                                            );

                                            const startingNumber = selectedSeries?.nextNumber || 1;

                                            const updated = recalculateSequences(
                                                newData,
                                                startingNumber,
                                                series
                                            );

                                            setDataSource(updated);
                                        }}
                                        style={{ width: '100px' }} placeholder='Split into'
                                    />
                                </Space>
                                {!isValid && (
                                    <div style={{ color: 'red', fontSize: '12px' }}>
                                        Total of child quantities must be equal to parent quantity.
                                    </div>
                                )}
                            </Space> : <></>}
                        </>
                    );
                } else {
                    return (
                        <Input
                            type='number'
                            onChange={(e) => {
                                const newData = [...dataSource];
                                for (const data of newData) {
                                    if (data?.children?.length) {
                                        for (const element of data.children) {
                                            if (record.key == element.key) {
                                                element.quantity = e.target.value;
                                                break;
                                            }
                                        }
                                    }
                                }
                                setDataSource(newData);
                            }}
                            value={record.quantity || ''}
                            placeholder="Quantity"
                        />
                    );
                }
            }
        },
        {
            title: 'Barcode/Batchcode Number',
            dataIndex: 'barcode',
            render: (text: any, record: any, index: number) => {
                return (!record.itemId && record?.key != "globalParent") ?
                    <Input.Group compact>
                        <Input
                            disabled={toggle}
                            onChange={(e) => {
                                const newData = [...dataSource];
                                for (const data of dataSource) {
                                    if (data?.children && data?.children?.length) {
                                        for (const element of data.children) {
                                            if (element.key == record.key) {
                                                element.prefix = e.target.value
                                                break;
                                            }
                                        }
                                    }
                                }
                                setDataSource(newData);
                            }}
                            value={record?.prefix || ''} style={{ width: '50%' }} placeholder="prefix" />
                        <Input
                            disabled={toggle}
                            onChange={(e) => {
                                const newData = [...dataSource];
                                for (const data of dataSource) {
                                    if (data?.children && data?.children?.length) {
                                        for (const element of data.children) {
                                            if (element.key == record.key) {
                                                element.sequence = e.target.value
                                                break;
                                            }
                                        }
                                    }
                                }
                                setDataSource(newData);
                            }}
                            value={record?.sequence || ''} style={{ width: '50%' }} type="number" placeholder="number" />
                    </Input.Group> :
                    <Input.Group compact>
                        <Input disabled={toggle} onChange={(e) => {
                            const prefix = e.target.value.trim();
                            if (prefix || prefix == '') {
                                if (record.key != 'globalParent') {
                                    const newData = [...dataSource];
                                    newData[index] = {
                                        ...newData[index],
                                        children: newData[index]?.children?.map?.((child: any) => {
                                            return {
                                                ...child,
                                                prefix
                                            }
                                        }),
                                        prefix
                                    }
                                    setDataSource(newData);
                                } else {
                                    const newData = [...dataSource];
                                    for (const data of dataSource) {
                                        data.prefix = prefix;
                                        if (data?.children && data?.children?.length) {
                                            for (const element of data.children) {
                                                element.prefix = prefix;
                                            }
                                        }
                                    }
                                    setDataSource(newData);
                                }
                            }
                        }}
                            value={record?.prefix || ''}
                            style={{ width: '50%' }} placeholder="prefix" />
                        <Input disabled={toggle} onChange={(e) => {
                            const sequence = Number(e.target.value.trim());
                            if (!isNaN(sequence)) {
                                if (record.key != 'globalParent') {
                                    const newData = [...dataSource];
                                    newData[index] = {
                                        ...newData[index],
                                        children: newData[index]?.children?.map?.((child: any, index: number) => {
                                            return {
                                                ...child,
                                                sequence: sequence + index
                                            }
                                        }),
                                        sequence
                                    }
                                    setDataSource(newData);
                                } else {
                                    const newData = [...dataSource];
                                    let counter = sequence, temp = sequence;
                                    for (const data of dataSource) {
                                        data.sequence = counter;
                                        temp = counter;
                                        if (data?.children && data?.children?.length) {
                                            for (const element of data.children) {
                                                element.sequence = temp;
                                                temp += 1;
                                            }
                                        }
                                        if (data.key != 'globalCounter') counter = temp;
                                    }
                                    setDataSource(newData);
                                }
                            }
                        }}
                            value={record?.sequence}
                            style={{ width: '50%' }} type="number" placeholder="number" />
                    </Input.Group>;
            },
        },
        {
            title: 'Manufacturing Date',
            dataIndex: 'manufacturingDate',
            render: (text: any, record: any, index: number) => {
                return (!record.itemId && record.key != 'globalParent') ?
                    <DatePicker
                        onChange={(date) => {
                            const newData = [...dataSource];
                            for (const data of dataSource) {
                                if (data?.children && data?.children?.length) {
                                    for (const element of data.children) {
                                        if (element.key == record.key) {
                                            element.manufacturingDate = date?.format?.('DD-MM-YYYY');
                                            break;
                                        }
                                    }
                                }
                            }
                            setDataSource(newData);
                        }}
                        value={record.manufacturingDate ? moment(record.manufacturingDate, 'DD-MM-YYYY') : null}
                        format="DD/MM/YYYY" />
                    :
                    <DatePicker value={record.manufacturingDate ? moment(record.manufacturingDate, 'DD-MM-YYYY') : null}
                        format="DD/MM/YYYY" onChange={(date) => {
                            const newData = [...dataSource];
                            if (record.key != 'globalParent') {
                                newData[index] = {
                                    ...newData[index],
                                    children: newData[index]?.children?.map?.((child: any) => {
                                        return {
                                            ...child,
                                            manufacturingDate: date?.format?.('DD-MM-YYYY')
                                        }
                                    }),
                                    manufacturingDate: date?.format?.('DD-MM-YYYY')
                                }
                                setDataSource(newData);
                            } else {
                                const newData = [...dataSource];
                                for (const data of dataSource) {
                                    data.manufacturingDate = date?.format?.('DD-MM-YYYY')
                                    if (data?.children && data?.children?.length) {
                                        for (const element of data.children) {
                                            element.manufacturingDate = date?.format?.('DD-MM-YYYY')
                                        }
                                    }
                                }
                                setDataSource(newData);
                            }
                        }}
                    />;
            },
        },
        {
            title: 'Expiry Date',
            dataIndex: 'expiryDate',
            width: 150,
            render: (text: any, record: any, index: number) => {
                return (!record.itemId && record.key != 'globalParent') ?
                    <DatePicker
                        onChange={(date) => {
                            const newData = [...dataSource];
                            for (const data of dataSource) {
                                if (data?.children && data?.children?.length) {
                                    for (const element of data.children) {
                                        if (element.key == record.key) {
                                            element.expiryDate = date?.format?.('DD-MM-YYYY');
                                            break;
                                        }
                                    }
                                }
                            }
                            setDataSource(newData);
                        }}
                        value={record.expiryDate ? moment(record.expiryDate, 'DD-MM-YYYY') : null}
                        format="DD/MM/YYYY" />
                    :
                    <DatePicker value={record.expiryDate ? moment(record.expiryDate, 'DD-MM-YYYY') : null}
                        format="DD/MM/YYYY" onChange={(date) => {
                            const newData = [...dataSource];
                            if (record.key != 'globalParent') {
                                newData[index] = {
                                    ...newData[index],
                                    children: newData[index]?.children?.map?.((child: any) => {
                                        return {
                                            ...child,
                                            expiryDate: date?.format?.('DD-MM-YYYY')
                                        }
                                    }),
                                    expiryDate: date?.format?.('DD-MM-YYYY')
                                }
                                setDataSource(newData);
                            }
                            else {
                                const newData = [...dataSource];
                                for (const data of dataSource) {
                                    data.expiryDate = date?.format?.('DD-MM-YYYY')
                                    if (data?.children && data?.children?.length) {
                                        for (const element of data.children) {
                                            element.expiryDate = date?.format?.('DD-MM-YYYY')
                                        }
                                    }
                                }
                                setDataSource(newData);
                            }
                        }} />;
            },
        },
        {
            title: '',
            dataIndex: 'actions',
            render: (text: any, record: any) => {
                if (!record.itemId) {
                    return (
                        <>
                            {
                                <Button
                                    danger
                                    type="text"
                                    icon={<DeleteOutlined />}
                                    onClick={() => handleDeleteRow(record.key)}
                                />
                            }
                        </>
                    );
                }
                return null;
            },
        },
    ];

    const selectColumns = [
        {
            title: "Item ID",
            dataIndex: "itemId",
            render: (t: string) => <strong>{t}</strong>,
        },
        { title: "Item Name", dataIndex: "itemName" },
        {
            title: "Remaining Consumption",
            dataIndex: "consumedToday",
            render: (_: any, r: any) => <span>{Math.abs(r.quantity)}</span>,
        },
        {
            title: "Select Batches",
            dataIndex: "selectedBatches",
            render: (_: any, record: any, index: number) => {
                const available = (b: any) =>
                    Math.max(
                        0,
                        (b.quantity || 0) - (b.outQuantity || 0) - (b.consumedQuantity || 0)
                    );

                const availableBatches: any[] = (record.batches || []).filter(
                    (b: any) => available(b) > 0
                );

                const selected: string[] = Array.isArray(record.selectedBatches)
                    ? record.selectedBatches
                    : [];
                const selectedCovered = selected.reduce((sum, code) => {
                    const b = availableBatches.find((x) => x.barCode === code);
                    return sum + (b ? available(b) : 0);
                }, 0);
                const fullyAllocated =
                    selectedCovered >= Math.abs(record.quantity || 0);

                return (
                    <Space direction="vertical">
                        <Select
                            mode="multiple"
                            style={{ width: 360 }}
                            placeholder="Select one or more batches"
                            value={selected}
                            onChange={(vals) => {
                                const newData = [...selectedDataSource];
                                newData[index].selectedBatches = vals;
                                setSelectedDataSource(newData);
                            }}
                            options={availableBatches.map((batch: any) => {
                                const isSelected = selected.includes(batch.barCode);
                                return {
                                    label: `${batch.barCode} (Avail: ${available(batch)})`,
                                    value: batch.barCode,
                                    // lock out extra picks once we've met/exceeded the need
                                    disabled: !isSelected && fullyAllocated,
                                };
                            })}
                        />
                        {fullyAllocated && (
                            <span style={{ fontSize: 12, opacity: 0.75 }}>
                                Fully allocated for {record.itemName}. Deselect to change
                                batches.
                            </span>
                        )}
                    </Space>
                );
            },
        },
        // {
        //     title: "",
        //     dataIndex: "actions",
        //     render: (_: any, record: any) => (
        //         <Button
        //             danger
        //             type="text"
        //             icon={<DeleteOutlined />}
        //             onClick={() => handleDeleteRow(record.key)}
        //         />
        //     ),
        // },
    ];

    const handleSubmit = () => {

        for (const element of dataSource) {
            if (element.key === "globalParent") continue;
            const parentQuantity = element.quantity;
            let childQuantity = 0;
            for (const item of element.children) {
                if (!item.quantity || !item.prefix || !item.sequence) {
                    notification.open({
                        type: 'error',
                        message: 'Prefix and sequence is required for all Rows.',
                        duration: 3
                    });
                    return;
                }
                childQuantity += Number(item.quantity);
            }
            if (childQuantity != parentQuantity) {
                notification.open({
                    type: 'error',
                    message: 'Invalid Quantity.',
                    duration: 3
                });
                return;
            }
        }
        const available = (b: any) =>
            Math.max(
                0,
                (b.quantity || 0) - (b.outQuantity || 0) - (b.consumedQuantity || 0)
            );
        const getBatchData = [];
        for (const element of [...selectedDataSource]) {

            const availableBatches: any[] = (element.batches || []).filter(
                (b: any) => available(b) > 0
            );

            const selected: string[] = Array.isArray(element.selectedBatches)
                ? element.selectedBatches
                : [];
            const selectedCovered = selected.reduce((sum, code) => {
                const b = availableBatches.find((x) => x.barCode === code);
                return sum + (b ? available(b) : 0);
            }, 0);
            const fullyAllocated =
                selectedCovered >= Math.abs(element.quantity || 0);
            if (!fullyAllocated) {
                notification.open({
                    type: 'error',
                    message: 'Select Batches for All Items',
                    duration: 3
                });
                return;
            }
            let remainingQuantity = Math.abs(element.quantity || 0);
            while (remainingQuantity > 0) {
                for (const element of selected) {
                    const b = [...availableBatches].find((x) => x.barCode === element);
                    const consumedToday = (b ? available(b) : 0)
                    b.consumedToday = Math.min(remainingQuantity, consumedToday);
                    remainingQuantity -= consumedToday;
                    getBatchData.push(b);
                }
            }

        }
        createSelectBatchItems({
            companyId,
            userId,
            getBatchData,
            approvalId,
            addBatchData: [...dataSource]?.filter((data: any) => data.key != "globalParent")
        });
    }

    useEffect(() => {

        let defaultSeries: any = null;

        if (Array.isArray(seriesData) && seriesData.length) {
            defaultSeries = seriesData.find(
                (s: any) => s.default && s.DocType === "Document Batch"
            );
        }

        const prefix = defaultSeries?.prefix || '';
        const startingNumber = defaultSeries?.nextNumber || 1;

        if (defaultSeries) {
            setSeries(prefix);
        }

        // 1️⃣ Build parent/child structure WITHOUT sequence
        let arr: any[] = [];

        itemsData
            ?.filter?.((item: any) => item?.id)
            ?.forEach?.((item: any) => {

                const acceptedQty = Number(
                    item?.accepted || item?.receivedToday
                ) || item?.quantity;

                const createParent = (
                    qty: number,
                    isRejected = false,
                    keySuffix = ''
                ) => ({
                    key: `${item.id}${keySuffix}`,
                    itemId: item?.item?.itemId,
                    parentItemId: item.itemId,
                    storeId: item?.toStoreId,
                    itemName: item?.item?.itemName,
                    quantity: qty,
                    prefix,
                    children: [
                        {
                            key: `${item.id}${keySuffix}-1`,
                            quantity: qty,
                            manufacturingDate: '',
                            expiryDate: '',
                            prefix
                        }
                    ],
                    split: '',
                    UOM: item?.item?.metricsUnit,
                    ...(isRejected && { isRejected: true })
                });
                arr.push(createParent(acceptedQty));

            });

        const baseData = [
            {
                key: 'globalParent',
                itemId: '',
                itemName: '',
                quantity: '',
                split: '',
                children: null,
                prefix
            },
            ...arr
        ];

        // 2️⃣ Centralized sequence calculation
        const updated = recalculateSequences(
            baseData,
            startingNumber,
            prefix
        );

        setDataSource(updated);

    }, [seriesData, isDrawerOpen, itemsData]);

    useEffect(() => {
        if (message) {
            getInventoryApprovalById({ approvalId, companyId });
            notification.open({
                message,
                type: 'success',
                duration: 3
            });
            dispatch({
                type: 'CREATE_SELECT_BATCHITEMS_SUCCESS',
                payload: {
                    responseData: {
                        message: ''
                    }
                }
            });
            setIsDrawerOpen(false);
        }
    }, [message]);

    useEffect(() => {
        const temp: any = {};
        if (Array.isArray(batchesData?.data)) {
            [...batchesData?.data].forEach((batch: any) => {
                const barCodeNumber = (isValidJSON(batch.barCodeNumber) || {});
                const barCode = barCodeNumber?.prefix + barCodeNumber?.number;
                if (temp[batch.item?.itemId]) {
                    temp[batch.item?.itemId].push({ ...batch, barCode });
                }
                else {
                    temp[batch.item?.itemId] = [{ ...batch, barCode }];
                }
            });
        }
        const arr: any = [...selectedItemsData];
        for (const element of arr) {
            element.itemId = element.item.itemId;
            element.itemName = element.item.itemName;
            if (temp[element.itemId]) element.batches = temp[element.itemId];
            else element.batches = [];
        }
        setSelectedDataSource(arr);

    }, [batchesData, selectedItemsData, isDrawerOpen]);

    return (
        <>
            <Loader loading={loading} />
            <Drawer
                title={'Add/Select Batch Code'}
                width={1200}
                onClose={() => {
                    setIsDrawerOpen(false);
                }}
                open={isDrawerOpen}
                styles={{
                    body: {
                        paddingBottom: 80,
                    },
                }}
                extra={
                    <Space>
                        <Button
                            onClick={() => {
                                const arr = [...dataSource];
                                const temp: any = [];
                                for (const element of arr) {
                                    if (element.key === 'globalParent') continue;
                                    for (const item of element.children) {
                                        if (item.sequence && item.prefix && item.quantity) {
                                            temp.push({
                                                sequence: item.sequence,
                                                prefix: item.prefix,
                                                quantity: item.quantity,
                                                uom: element.UOM,
                                                itemId: element.itemId,
                                                itemName: element.itemName,
                                                manufacturingDate: item.manufacturingDate,
                                                expiryDate: item.expiryDate
                                            });
                                        }
                                    }
                                    setPrintData(temp);
                                    setIsVisible(true);
                                }
                            }}
                        >
                            Preview Barcode
                        </Button>
                        <Button
                            onClick={() => {
                                setIsDrawerOpen(false);
                            }}
                            className="buttomCancelMobView"
                        >
                            Cancel
                        </Button>
                        <Button onClick={handleSubmit} type="primary">
                            Save Batches
                        </Button>
                    </Space>
                }
            >
                <BarcodePrint
                    isVisible={isVisible}
                    setIsVisible={setIsVisible}
                    data={printData}
                />
                {Array.isArray(dataSource) && dataSource?.length > 0 && <>
                    <div style={{ display: "flex", marginBottom: 12, gap: 8 }}>
                        <Select
                            disabled={!toggle}
                            value={series}
                            onChange={(value) => {
                                const selectedSeries = seriesData?.find(
                                    (s: any) => s.prefix === value
                                );

                                const startingNumber = selectedSeries?.nextNumber || 1;

                                const updated = recalculateSequences(
                                    [...dataSource],
                                    startingNumber,
                                    value
                                );

                                setDataSource(updated);
                                setSeries(value);
                            }}
                            placeholder='Select Barcode Series' style={{ width: 200 }}>
                            {
                                Array.isArray(seriesData) && seriesData?.length ? seriesData?.filter((series: any) => series?.DocType === "Document Batch")?.map((series: any) => (
                                    <Select.Option key={series.id} value={series.prefix}>{series.prefix}</Select.Option>
                                )) : null
                            }
                        </Select>
                        <div className="switch-label">
                            <p>Manual</p>
                            <Switch checked={toggle} onChange={(checked) => {
                                setToggle(checked);
                                if (checked && series) {
                                    const selectedSeries = seriesData?.find(
                                        (s: any) => s.prefix === series
                                    );

                                    const startingNumber = selectedSeries?.nextNumber || 1;

                                    const updated = recalculateSequences(
                                        [...dataSource],
                                        startingNumber,
                                        series
                                    );

                                    setDataSource(updated);
                                }
                            }} />
                            <p>Auto</p>
                            <div></div>
                        </div>
                    </div>
                    <h6>Add Batches</h6>
                    <Table
                        style={{ height: '300px' }}
                        dataSource={dataSource}
                        columns={columns}
                        pagination={false}
                        rowKey="key"

                    />
                </>}
                {Array.isArray(selectedDataSource) && selectedDataSource?.length > 0 && <>
                    <hr />
                    <h6>Select Batches</h6>
                    <Table
                        style={{ height: '300px' }}
                        dataSource={selectedDataSource}
                        columns={selectColumns}
                        pagination={false}
                        rowKey="key"
                    />
                </>}
            </Drawer>
        </>
    )
}

const mapStateToProps = (state: any) => ({
    companyId: state.api.login.data.companyId,
    userId: state.api.login.data.id,
    seriesData: state.api.getDocumentSeries?.data,
    loading: state.api.createSelectBatchItems.loading,
    message: state.api.createSelectBatchItems.data,
    batchesData: state.api.getBatchItems.batchItems
})

const mapDispatchToProps = (dispatch: any) => ({
    getDocumentSeries: (payload: any) => dispatch(getDocumentSeries(payload)),
    createSelectBatchItems: (payload: any) => dispatch(createSelectBatchItems(payload)),
    getInventoryApprovalById: (payload: any) => dispatch(getInventoryApprovalById(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddSelectBatch);
